import { get, post } from '@/shared/services/api'

export function getVideoCategoryList() {
  const url = '/videos/category-list'
  return get(url, {}).then((response) => response)
}

export function getCategory(data) {
  const url = '/videos/category'
  return get(url, data).then((response) => response)
}

export function getVideosList(category) {
  const url = '/videos/videos-list'
  return get(url, { params: { category: category } }).then(
    (response) => response
  )
}

export function getVideoCard(data) {
  const url = '/videos/video-card'
  return get(url, data).then((response) => response)
}
